import { createActionConst } from '../../../utils/action.utils';

const SUBSCRIPTION_ACCESS_NAMESPACE = 'SUBSCRIPTION_ACCESS_NAMESPACE';

export const STORE_SUBSCRIPTION_ACCESS = createActionConst(SUBSCRIPTION_ACCESS_NAMESPACE, 'STORE_SUBSCRIPTION_ACCESS');
export const CLEAR_SUBSCRIPTION_ACCESS = createActionConst(SUBSCRIPTION_ACCESS_NAMESPACE, 'CLEAR_SUBSCRIPTION_ACCESS');
